import { ADS_CONFIG } from './configs/adsConfig';

const CURRENT_ENVIRONMENT =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging' ||
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'production'
    : 'development';

export const ADS_CONSTANTS = ADS_CONFIG[CURRENT_ENVIRONMENT];
